import { render, staticRenderFns } from "./CustomerBasicTab.vue?vue&type=template&id=2f6c5fb3&"
import script from "./CustomerBasicTab.vue?vue&type=script&lang=js&"
export * from "./CustomerBasicTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomerBasicTab.vue"
export default component.exports